module.exports = __webpack_public_path__ + "static/media/tracking.dbd6aa8e.svg";